var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouthpiece(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 7,
    fill: "url(#paint0_linear_197_681)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4375 11.1421C27.589 10.6876 27.3434 10.1964 26.889 10.0448C26.4344 9.89323 25.9432 10.1388 25.7916 10.5933L24.9241 13.1945C24.7726 13.649 25.0182 14.1402 25.4726 14.2918C25.9272 14.4434 26.4184 14.1978 26.57 13.7433L27.4375 11.1421ZM32.7216 11.1218C33.0603 11.4605 33.0603 12.0098 32.7216 12.3486L29.83 15.2401C29.4913 15.5789 28.9421 15.5789 28.6033 15.2401C28.2646 14.9013 28.2646 14.3521 28.6033 14.0133L31.4949 11.1218C31.8336 10.783 32.3828 10.783 32.7216 11.1218ZM22.4165 12.8812C21.1258 11.4986 18.8489 11.845 18.0279 13.5489L11.2064 27.7066C10.8126 28.524 10.9935 29.5024 11.6536 30.125L13.3177 31.6943C13.9276 32.2694 14.823 32.4226 15.5894 32.083L17.2289 31.3567C17.9715 32.9195 19.5645 34 21.4099 34C23.9651 34 26.0363 31.9286 26.0363 29.3735C26.0363 28.7486 25.9125 28.1527 25.688 27.6089L29.6435 25.8564C31.3343 25.1074 31.7819 22.9147 30.5201 21.5628L22.4165 12.8812ZM24.1005 28.3122C24.2302 28.6408 24.3014 28.9989 24.3014 29.3735C24.3014 30.9705 23.0069 32.2651 21.4099 32.2651C20.2725 32.2651 19.2885 31.6084 18.8163 30.6535L24.1005 28.3122ZM29.5058 18.0957C29.5058 17.6166 29.8942 17.2282 30.3733 17.2282H32.6865C33.1656 17.2282 33.554 17.6166 33.554 18.0957C33.554 18.5748 33.1656 18.9632 32.6865 18.9632H30.3733C29.8942 18.9632 29.5058 18.5748 29.5058 18.0957Z",
    fill: "url(#paint1_linear_197_681)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_681",
    x1: -5.90244,
    y1: -5.36585,
    x2: 44,
    y2: 48.8293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A31F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A31F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_681",
    x1: 15.5,
    y1: 10.5,
    x2: 30,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthpiece);
export default __webpack_public_path__ + "static/media/mouthpiece.18a6af824be57ed106985d71781d6dbf.svg";
export { ForwardRef as ReactComponent };